module.exports = __webpack_public_path__ + "img/1537222907.ed320241.jpg";